import * as Sentry from '@sentry/react';

import { BRANCH, BUILD_ID, COMMIT_ID, ENV, SENTRY_DSN, VERSION } from '@/env';

export const initSentry = () => {
  Sentry.init({
    dsn: SENTRY_DSN,
    environment: ENV,
    sendDefaultPii: true,
    tracesSampleRate: 1.0
  });

  Sentry.setTags({
    buildId: BUILD_ID,
    branch: BRANCH,
    commitId: COMMIT_ID,
    version: VERSION
  });
};
